import { Button } from "@win-reality/react-ui";
import { useDispatch, useSelector } from "react-redux";

import {
  BASEBALL_PITCH_TYPES,
  SOFTBALL_PITCH_TYPES,
} from "../../../constants/pitchTypes";
import { putTag, removeTag } from "../../../store/slices/session";
import type { RootState } from "../../../store/store";

export const BullpenPitchTypeButtons = () => {
  const dispatch = useDispatch();
  const sport = useSelector((state: RootState) => state.session.sport);
  const selectedPitchType = useSelector(
    (state: RootState) => state.session.tagData?.pitchType,
  );

  const pitchTypes =
    sport?.toLowerCase() === "softball"
      ? SOFTBALL_PITCH_TYPES
      : BASEBALL_PITCH_TYPES;

  const handlePitchTypeClick = (value: string) => {
    if (selectedPitchType === value) {
      dispatch(removeTag({ key: "pitchType" }));
    } else {
      dispatch(putTag({ key: "pitchType", value }));
    }
  };

  return (
    <div className="grid grid-cols-4 gap-2 rounded bg-white p-3 shadow-md">
      {pitchTypes.map((pt) => (
        <Button
          key={pt.value}
          size="sm"
          variant={selectedPitchType === pt.value ? "blue" : "ghost"}
          onClick={() => handlePitchTypeClick(pt.value)}
          className="w-full normal-case border border-gray-300"
        >
          {pt.label}
        </Button>
      ))}
    </div>
  );
};
